module.exports = __webpack_public_path__ + "static/img/merchant_feature_6.ba59624.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_6.png
// module id = 81y6
// module chunks = 8